import React, { useEffect, useState } from 'react';
import myconfig from '../Config';

interface AuthImageProps {
  // API path relative to rootUrl, e.g. /api/photos/Image/12/thumb
  path: string;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
  // Optional element shown while the image is loading or unavailable (e.g. still being processed).
  placeholder?: React.ReactNode;
}

// Renders an image from an endpoint that requires a JWT (a private Azure container proxied by the
// API). Fetches the blob with the bearer token, displays it via an object URL, and revokes the URL
// on unmount/refetch. Until the blob is available it renders `placeholder` (or nothing).
const AuthImage: React.FC<AuthImageProps> = ({ path, alt = '', style, className, onClick, placeholder = null }) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    setUrl(null);
    (async () => {
      try {
        const token = localStorage.getItem('myToken');
        const res = await fetch(`${myconfig.rootUrl}${path}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) return;
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch { /* image not available yet */ }
    })();
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);

  if (!url) return <>{placeholder}</>;
  return <img src={url} alt={alt} style={style} className={className} onClick={onClick} />;
};

export default AuthImage;
